/* unplugin-vue-components disabled */import { render } from "./ReportDetail.vue?vue&type=template&id=08e5dc66&scoped=true&ts=true"
import script from "./ReportDetail.vue?vue&type=script&lang=ts"
export * from "./ReportDetail.vue?vue&type=script&lang=ts"

import "./ReportDetail.vue?vue&type=style&index=0&id=08e5dc66&lang=less&scoped=true"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08e5dc66"]])

export default __exports__